import { MEAL } from '../../products';
import { NO_OPTION } from './mealUtil';
import { getMealState } from './units';
import { getNoneSelected } from './smallMealUtil';
const getGraphQlSelection = _ref => {
  let {
    state,
    form
  } = _ref;
  const formData = getMealState(form, state);
  if (!formData) {
    return null;
  }
  const selected = formData.filter(_ref2 => {
    let {
      value
    } = _ref2;
    return String(value) !== NO_OPTION;
  });
  if (!selected || !selected.length) {
    return null;
  }
  return {
    productId: String(MEAL.id),
    selectionTravelerChoice: selected.map(value => ({
      travelerId: Number(value.travelerId),
      choiceId: Number(value.choiceId)
    }))
  };
};
export const getDBFGraphQlSelection = _ref3 => {
  let {
    state,
    form
  } = _ref3;
  const formData = getMealState(form, state);
  const selected = formData === null || formData === void 0 ? void 0 : formData.filter(_ref4 => {
    let {
      value
    } = _ref4;
    return String(value) !== NO_OPTION;
  });

  // This case handles small card radio button selection
  const isNoneSelected = getNoneSelected(form, MEAL.name)(state);
  if (isNoneSelected || !(selected !== null && selected !== void 0 && selected.length)) {
    return {
      productId: String(MEAL.id),
      selectionTravelerChoice: []
    };
  }
  return {
    productId: String(MEAL.id),
    selectionTravelerChoice: selected.map(value => ({
      travelerId: Number(value.travelerId),
      choiceId: Number(value.choiceId)
    }))
  };
};
export default getGraphQlSelection;
//# sourceMappingURL=getGraphQlSelection.js.map